import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Flex, Box } from 'core/components';

import { ALERT_UI_STATES } from '@kentik/ui-shared/alerting/constants';
import AlertingSiteHealthTable from './components/AlertingSiteHealthTable';
import AlertingSiteHealthMap from './components/healthMap';

@inject('$metrics')
@withRouter
@observer
class AlertingSiteHealthWrapper extends Component {
  handleNavigateToSiteFilterView = (siteId) => {
    const { history, lookback, startDate, endDate } = this.props;
    const LOOKBACK_90_DAYS = 3600 * 24 * 90;

    const filters = {
      groupBy: 'severity',
      sites: [siteId]
    };

    // If using custom date range, pass startDate/endDate and set lookback to 0
    if (startDate && endDate) {
      filters.startDate = startDate;
      filters.endDate = endDate;
      filters.lookback = 0;
      filters.states = [ALERT_UI_STATES.CLEAR, ALERT_UI_STATES.ACTIVE];
    } else {
      // Otherwise use lookback
      const effectiveLookback = lookback || 3600;
      filters.lookback = effectiveLookback > LOOKBACK_90_DAYS ? LOOKBACK_90_DAYS : effectiveLookback;
      filters.states =
        effectiveLookback > 0 ? [ALERT_UI_STATES.CLEAR, ALERT_UI_STATES.ACTIVE] : [ALERT_UI_STATES.ACTIVE];
    }

    history.push('/v4/alerting/', { filters });
  };

  render() {
    const { maxHeight, minHeight, collection, groupBy, loading } = this.props;

    return (
      <Flex height="100%" width="100%" maxWidth="100%" overflow="hidden" maxHeight={maxHeight} minHeight={minHeight}>
        <AlertingSiteHealthMap
          flex={2}
          minWidth={0}
          collection={collection}
          fetchStatus={`${collection.lastFetched}-${collection.requestStatus}`}
          navigateToSiteFilterView={this.handleNavigateToSiteFilterView}
        />

        <Box
          flex={1}
          minWidth={groupBy === 'severity' ? '540px' : undefined}
          style={{ overflowX: 'auto', overflowY: 'hidden' }}
          p={1}
          pr={0}
          pb={0}
        >
          <AlertingSiteHealthTable
            loading={loading}
            collection={collection}
            groupBy={groupBy}
            navigateToSiteFilterView={this.handleNavigateToSiteFilterView}
          />
        </Box>
      </Flex>
    );
  }
}

export default AlertingSiteHealthWrapper;
